/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} User_Detail_Hof_CountInputs */



/**
* | output |
* | --- |
* | "Hall of Fame: {count}" |
*
* @param {User_Detail_Hof_CountInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_detail_hof_count = /** @type {((inputs: User_Detail_Hof_CountInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Detail_Hof_CountInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Hall of Fame : ${i?.count}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Hall of Fame: ${i?.count}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Hall da Fama: ${i?.count}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Hall of Fame: ${i?.count}`)
	return /** @type {LocalizedString} */ (`Hall of Fame: ${i?.count}`)
});